import React, { useState } from 'react';
import PropTypes from 'prop-types';

const mockFunction = () => {
  /* empty */
};

const AreaActiveDot = ({
  color = 'var(--cornflowerBlue)',
  cx,
  cy,
  onClick = mockFunction,
  onEnter = mockFunction,
  onLeave = mockFunction,
  ...otherProps
}) => {
  const [timer, setTimer] = useState(undefined);

  const onDotClicked = () => {
    onClick({ cx, cy, color, ...otherProps });
  };

  const mouseEnterHandler = () => {
    setTimer(
      setTimeout(() => {
        onEnter({ cx, cy, color, ...otherProps });
      }, 300)
    );
  };

  const mouseLeaveHandler = () => {
    clearTimeout(timer);
    setTimer(undefined);
    onLeave();
  };

  return (
    <circle
      cursor="pointer"
      onClick={onDotClicked}
      onMouseEnter={mouseEnterHandler}
      onMouseLeave={mouseLeaveHandler}
      cx={cx}
      cy={cy}
      r={4}
      stroke={color}
      strokeWidth={1}
      fill="var(--white)"
    />
  );
};

AreaActiveDot.propTypes = {
  color: PropTypes.string,
  cx: PropTypes.number,
  cy: PropTypes.number,
  onClick: PropTypes.func,
  onEnter: PropTypes.func,
  onLeave: PropTypes.func
};

export default AreaActiveDot;
